export const portfolios = [
  {
    id: 1,
    categories: "cat--1 cat--4",
    title: "Utvikling av styresystem for boretårn",
    subtitle: "development",
    imgSrc: "/images/gerold-hinzen-VCnw5s0Y9Ew-unsplash.jpg",
    altText: "Portfolio-01",
    images: [
      '/images/bernd-dittrich-LrgCaGgfTtM-unsplash.jpg',
      '/images/chelsea-WvusC5M-TM8-unsplash.jpg',
      '/images/nasa-Q1p7bh3SHj8-unsplash.jpg',
    ],
  },
  {
    id: 2,
    categories: "cat--2 cat--3",
    title: "Styresystem for bygninger",
    subtitle: "development",
    imgSrc: "/images/igor-saikin-E840iJGN8_k-unsplash.jpg",
    altText: "Portfolio-02",
  },
  {
    id: 3,
    categories: "cat--3 cat--4 cat--1",
    title: "Skyløsning for styresystem",
    subtitle: "development",
    imgSrc: "/images/growtika-F-Y1EuDHr-4-unsplash.jpg",
    altText: "Portfolio-03",
  },
];
export const portfolioItems = [
  {
    id: 7,
    category: "cat--1 cat--4",
    imageSrc: "/assets/images/portfolio/portfolio-01.jpg",
    alt: "Portfolio-01",
  },
  {
    id: 8,
    category: "cat--2 cat--3",
    imageSrc: "/assets/images/portfolio/portfolio-02.jpg",
    alt: "Portfolio-02",
  },
  {
    id: 9,
    category: "cat--3 cat--4 cat--1",
    imageSrc: "/assets/images/portfolio/portfolio-03.jpg",
    alt: "Portfolio-03",
  },
  {
    id: 10,
    category: "cat--3 cat--2",
    imageSrc: "/assets/images/portfolio/portfolio-04.jpg",
    alt: "Portfolio-04",
  },
  {
    id: 11,
    category: "cat--2 cat--4",
    imageSrc: "/assets/images/portfolio/portfolio-05.jpg",
    alt: "Portfolio-05",
  },
  {
    id: 12,
    category: "cat--3 cat--2 cat--1",
    imageSrc: "/assets/images/portfolio/portfolio-06.jpg",
    alt: "Portfolio-06",
  },
  {
    id: 13,
    category: "cat--4",
    imageSrc: "/assets/images/portfolio/portfolio-02.jpg",
    alt: "Portfolio-02",
  },
  {
    id: 14,
    category: "cat--4 cat--2",
    imageSrc: "/assets/images/portfolio/portfolio-01.jpg",
    alt: "Portfolio-01",
  },
  {
    id: 15,
    category: "cat--1 cat--4",
    imageSrc: "/assets/images/portfolio/portfolio-01.jpg",
    alt: "Portfolio-01",
  },
  {
    id: 16,
    category: "cat--2 cat--3",
    imageSrc: "/assets/images/portfolio/portfolio-02.jpg",
    alt: "Portfolio-02",
  },
  {
    id: 17,
    category: "cat--3 cat--4 cat--1",
    imageSrc: "/assets/images/portfolio/portfolio-03.jpg",
    alt: "Portfolio-03",
  },
  {
    id: 18,
    category: "cat--3 cat--2",
    imageSrc: "/assets/images/portfolio/portfolio-04.jpg",
    alt: "Portfolio-04",
  },
];

export const allPortfolios: any[] = [...portfolios, ...portfolioItems];
export const filterButtons = [
  {
    filter: "*",
    label: "All",
  },
  {
    filter: ".cat--4",
    label: "development",
  },
];
